import { useTranslation } from 'react-i18next';

export default function ReceiptPage() {
  const { t } = useTranslation();

  return (
    <div className="border-neutral-5 shadow-md-8 mx-auto mt-40 flex w-fit flex-col justify-center gap-6 rounded-md border bg-white p-5">
      <h2 className="typ-headline-md text-blue-110 flex w-full justify-center">
        {t('common.receipt.anonymous.title')}
      </h2>
      <p style={{ fontSize: '1.1rem', maxWidth: '400px' }}>
        {t('common.receipt.anonymous.message')}
      </p>
    </div>
  );
}
